import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  DownloadAllVoucher: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
